export const saveAs = (file, fileName = 'fileName') => {
  // Create blob link to download
  const url = window.URL.createObjectURL(file)
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)

  // Append to html link element page
  document.body.appendChild(link)

  // Start download
  link.click()

  // Clean up and remove the link; the file's URL is released once the download has started
  link.parentNode.removeChild(link)
  setTimeout(() => window.URL.revokeObjectURL(url), 10000)
}
